const EXCHANGE_BRAND_USER_TYPES = {
    BASE: 0,
    EXCHANGE_ADMIN: 255,
};
const EXCHANGE_BRAND_ENTITY_TYPES = {
    BUSINESS: 0,
    INDIVIDUAL: 1,
};
const EXCHANGE_BRAND_SCHOOL_STATUSES = {
    PENDING: 0,
    VERIFIED: 1,
    DENIED: 2,
};
export { EXCHANGE_BRAND_USER_TYPES, EXCHANGE_BRAND_ENTITY_TYPES, EXCHANGE_BRAND_SCHOOL_STATUSES, };
